import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type Response } from '@/infra/services/catalog/product/get-region-by-zip-code';

interface UseRegionByZipCode {
  zipCode: string;
}

type QueryOptions = Omit<
  UseQueryOptions<Response, Error, Response>,
  'queryKey' | 'queryFn'
>;

const useRegionByZipCode = (
  props: UseRegionByZipCode,
  options?: QueryOptions
) => {
  const { zipCode } = props;

  const result = useQuery<Response, Error, Response>({
    queryKey: ['get-region-by-zip-code', zipCode],
    retry: false,
    staleTime: Infinity,
    queryFn: () => Services.Catalog.Product.getRegionByZipCode({ zipCode }),
    ...options,
  });

  return result;
};

export default useRegionByZipCode;
